import React, { useEffect, useState } from 'react';

import SuiteEnum from 'redpoints-model-js-common/enumeration/SuiteEnum';

import { Col, Row } from 'redpoints-front-components/index';
import { Looker } from 'redpoints-front-common/components';
import { getPermission } from 'redpoints-front-common/helpers';

import BoxesSelector from './BoxesSelector/BoxesSelector';
import { HOME_INFOBOXES_ENTITY } from '../../config/constants';

import './home.less';

const Home = ({ context, dashboard, translation }) => {
  const [hasInfoboxesPermission, setHasInfoboxesPermission] = useState(false);

  useEffect(() => {
    (async () => {
      const hasPermission = await getPermission({
        context,
        entity: HOME_INFOBOXES_ENTITY,
        suite: SuiteEnum.IPR,
      });
      setHasInfoboxesPermission(hasPermission);
    })();
  }, [context]);

  return (
    <div className="home_page">
      <Row className="home_alert_boxes" type="flex" gutter={30}>
        {hasInfoboxesPermission && (
          <BoxesSelector context={context} translation={translation} />
        )}
      </Row>
      <Row type="flex" justify="start" align="middle" gutter={30}>
        <Col span={24}>
          <Looker dashboard={dashboard} />
        </Col>
      </Row>
    </div>
  );
};

export default Home;
